module.exports = __webpack_public_path__ + "images/emoji/carousel_horse.33e337cbf5e542c7d98f.png";